import variance from "./variance";

export default function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/deviation.js
// module id = q0nS
// module chunks = 0